import VehicleSearch from "./VehicleSearch";

function Hero({ selectedMakes, selectedModels, onToggleMake, onToggleModel, onSelectAllMakes, onSelectAllModels }) {
  const scrollToVehicles = () => {
    document.getElementById("vehicles")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Pre-owned Colombian Armored Vehicles</h1>
          <h2>Superior Protection, Exceptional Value - Sourced in Colombia & Shipped Worldwide</h2>
          <VehicleSearch
            selectedMakes={selectedMakes}
            selectedModels={selectedModels}
            onToggleMake={onToggleMake}
            onToggleModel={onToggleModel}
            onSelectAllMakes={onSelectAllMakes}
            onSelectAllModels={onSelectAllModels}
            onSearch={scrollToVehicles}
          />
          <button onClick={scrollToVehicles} className="cta-button">
            Get in touch with us now!
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
